import React from "react";
import PositionsStartStop from "../components/report/PositionsStartStop";
// import Positions from "../components/report/Positions";
// import useSrlHelper from "../hooks/useSrlHelper";

const PositionsWrapper = ({}) => {
  // const { isSrl } = useSrlHelper();

  return (
    <React.Fragment>
      {/* Same for all */}
      <PositionsStartStop />
      {/* {isSrl() ? (
        <React.Fragment>
          <PositionsStartStop />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Positions />
        </React.Fragment>
      )} */}
    </React.Fragment>
  );
};

export default PositionsWrapper;
